import { Typography } from "@carrotfertility/carotene-core"
import React from "react"

export function renderSelectWithPlaceholder(options: { label: string; value: string }[], placeholder: string) {
  function returnSelectedOptionsOrPlaceholder(value: any): React.ReactNode {
    const option = options.find((option) => option.value === value)
    return option ? (
      option.label
    ) : (
      <Typography component="span" color={(theme) => theme.palette.placeholder}>
        {placeholder}
      </Typography>
    )
  }

  return returnSelectedOptionsOrPlaceholder
}

export function renderSelectWithPlaceholderMultiSelect(
  options: { label: string; value: string }[],
  placeholder: string
) {
  function returnSelectedOptionsOrPlaceholder(value: any): React.ReactNode {
    if (Array.isArray(value) && value.length > 0) {
      return value.map((value) => options.find((option) => option.value === value)?.label).join(", ")
    }

    return (
      <Typography component="span" color={(theme) => theme.palette.placeholder}>
        {placeholder}
      </Typography>
    )
  }

  return returnSelectedOptionsOrPlaceholder
}
